import { render, staticRenderFns } from "./LatestAutomaticInvestmentTermsConditionsContract.vue?vue&type=template&id=23903484&scoped=true&"
import script from "./LatestAutomaticInvestmentTermsConditionsContract.vue?vue&type=script&lang=js&"
export * from "./LatestAutomaticInvestmentTermsConditionsContract.vue?vue&type=script&lang=js&"
import style0 from "./LatestAutomaticInvestmentTermsConditionsContract.vue?vue&type=style&index=0&id=23903484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23903484",
  null
  
)

export default component.exports